/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchActors.defs'
export { main as default } from './searchActors.defs'
